import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import {
  blackShade43,
  greyColor40,
  logoImgborder1,
  whiteColor,
} from "../../../configs/styles/muiThemes";

function BusinessInfoCard({ activeBusinessInfo }) {
  return (
    <Stack
      gap="12px"
      sx={{
        p: "12px",
        background: whiteColor,
        border: logoImgborder1,
        borderRadius: "8px",
      }}
    >
      <InfoCard
        title="Registered Business Name"
        value={activeBusinessInfo?.aliasName}
      />
      <InfoCard
        title="FSSAI No"
        value={
          activeBusinessInfo?.rewardCurrency &&
          activeBusinessInfo?.rewardCurrency !== "₹"
            ? activeBusinessInfo.rewardCurrency
            : "-"
        }
      />
    </Stack>
  );
}

export default BusinessInfoCard;

const InfoCard = ({ title, value }) => {
  return (
    <Stack>
      <Typography
        fontSize={11.2}
        lineHeight="14px"
        fontWeight={500}
        color={greyColor40}
        mb="2px"
      >
        {title}
      </Typography>
      <Typography
        fontSize={{ xs: 11.5, md: 12 }}
        fontWeight={600}
        color={blackShade43}
        lineHeight={{ xs: "19px", md: "22px" }}
      >
        {value}
      </Typography>
    </Stack>
  );
};
